import { render, staticRenderFns } from "./VisitaTecninca.vue?vue&type=template&id=69b6c89d&scoped=true"
import script from "./VisitaTecninca.vue?vue&type=script&lang=js"
export * from "./VisitaTecninca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b6c89d",
  null
  
)

export default component.exports